export default function Go_if_statement () {
  return (
    <div>
      <h1>Go_if_statement </h1>
      <p>if statement</p>
    </div>
  );
}